import { useState } from "react";
import { api } from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime, fmtMoney } from "../../lib/format";
import { useAdminData, SearchBox, FilterSelect, Pager, TableCard, TH } from "./shared";

export default function AdminPayments() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminPayments);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-payments-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search payment or PaymentIntent id…" testid="admin-payments-search" />
        <FilterSelect value={filters.status || ""} onChange={(v) => setFilters((f) => ({ ...f, status: v }))} label="Status filter" testid="admin-payments-status"
                      options={[["", "All statuses"], ["succeeded", "Succeeded"], ["authorized", "Authorized"], ["failed", "Failed"], ["refunded", "Refunded"]]} />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading payments…" /> : (
        <>
          <TableCard testid="admin-payments-table" empty={rows.length === 0 && "No payments found."}
            head={<><TH>Payment</TH><TH>Total</TH><TH>Fee</TH><TH>Host payout</TH><TH>Status</TH><TH>Date</TH></>}>
            {rows.map((p) => (
              <tr key={p.payment_id} className="border-b border-[#18181B]" data-testid={`admin-payment-${p.payment_id}`}>
                <td className="p-4 text-xs font-mono text-zinc-400">{p.payment_id}</td>
                <td className="p-4">{fmtMoney(p.amount_total, (p.currency || "").toUpperCase() || undefined)}</td>
                <td className="p-4">{fmtMoney(p.platform_fee, (p.currency || "").toUpperCase() || undefined)}</td>
                <td className="p-4">{fmtMoney(p.host_payout, (p.currency || "").toUpperCase() || undefined)}</td>
                <td className="p-4"><StatusBadge value={p.status === "succeeded" ? "paid" : p.status} /></td>
                <td className="p-4 text-xs text-zinc-500">{fmtDateTime(p.created_at)}</td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-payments-pager" />
        </>
      )}
    </div>
  );
}
